import { MenuLinkItem } from '@affine/core/modules/app-sidebar/views';
import { WorkbenchService } from '@affine/core/modules/workbench';
import { ViewLayersIcon } from '@blocksuite/icons/rc';
import { useLiveData, useServices } from '@toeverything/infra';

export const NotesButton = () => {
  const { workbenchService } = useServices({
    WorkbenchService,
  });
  const workbench = workbenchService.workbench;
  const active = useLiveData(
    workbench.location$.selector(
      (location: { pathname: string }) => location.pathname === '/notes'
    )
  );

  return (
    <MenuLinkItem icon={<ViewLayersIcon />} active={active} to={'/notes'}>
      <span data-testid="notes">Notes</span>
    </MenuLinkItem>
  );
};
